// @ts-nocheck

import { useEffect } from 'react';

import { isLibrary } from '../../lib/useragent';

type DocumentTitleProps = {
  title: string;
  children?: React.ReactNode;
};

const DocumentTitle = ({ title, children = null }: DocumentTitleProps) => {
  useEffect(() => {
    if (!isLibrary && title) {
      document.title = title;
    }
  }, [title]);

  return children;
};

export default DocumentTitle;
